export default {"src":"/_next/static/media/messages.c37c85ea.svg","height":780,"width":664};